import axios from 'axios';
import BaseAPI from './base/base-api';

class SettingSystemAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'settingsystem';
}

export default new SettingSystemAPI();